import {
  TRANSPORT_METHOD_TYPE,
  TransportMethodType,
} from '@savgroup-front-common/core/api/Claim/getClaimGroupTransportPlanQuery';
import { ICONS_TYPE } from '@savgroup-front-common/types/Icon';

const getHandlingCardIcon = ({
  transportMethodType,
}: {
  transportMethodType: TransportMethodType;
}) => {
  switch (transportMethodType) {
    case TRANSPORT_METHOD_TYPE.HomeIntervention:
    case TRANSPORT_METHOD_TYPE.HomeDelivery:
    case TRANSPORT_METHOD_TYPE.HomePickup:
    case TRANSPORT_METHOD_TYPE.HomePickupProvidedBySeller:
    case TRANSPORT_METHOD_TYPE.BulkyHomeDelivery:
    case TRANSPORT_METHOD_TYPE.LabelProvidedByCustomer:
    case TRANSPORT_METHOD_TYPE.LabelProvidedBySeller:
      return ICONS_TYPE.HOME_ICON;

    case TRANSPORT_METHOD_TYPE.DropAtStoreDeposit:
    case TRANSPORT_METHOD_TYPE.ImmediateDropAtStoreDeposit:
    case TRANSPORT_METHOD_TYPE.PickUpStoreDelivery:
    case TRANSPORT_METHOD_TYPE.OnSiteCollection:
      return ICONS_TYPE.SMALL_SHOP_ICON;
    case TRANSPORT_METHOD_TYPE.PickUpRelayPointDelivery:
    case TRANSPORT_METHOD_TYPE.RelayPointDeposit:
      return ICONS_TYPE.BOX_ICON;

    default:
      return ICONS_TYPE.DELIVERY_TRUCK_ICON;
  }
};

export default getHandlingCardIcon;
